<template>
	<div class="main">
		<div class="grzx-left">
			<div class="user-name">
				{{userInfo.name}}
			</div>
			<div class="user-head">
				<img :src="userInfo.headImg ? $imgUrl + userInfo.headImg : '../../../static/user_head.png'" alt="">
			</div>
			<Upload
				class="change-head-button"
				ref="img_ref"
				:action="$baseUrl + '/sys/accessory/uploadFile'"
				:on-success="successUpload"
				:max-size="10240"
				name="uploadFile">
				{{lang == 'zh' ? '修改头像' : 'Change Avatar'}}
			</Upload>
			<!-- <div class="user-level">
				<div class="left">
					<i class="iconfont iconcollection-b"></i>
					<i class="iconfont iconcollection-b"></i>
				</div>
				<div class="right">
					中校
				</div>
			</div> -->
			<div class="user-point">
				{{lang == 'zh' ? '总积分' : 'Total Point'}}：{{userInfo.integral}}
			</div>
			<div class="grzx-box" v-for="(item, index) in leftList" @click="jumpTo(index)" :style="{borderBottom: index == 4 ? '' : '1px solid #C5C5C5', color: index === selectIndex ? '#2D5AC3' : ''}">
				<div>
					<i class="iconfont" :class="item.icon">

					</i>
				</div>
				<div style="margin-left: 10px;">
					{{lang == 'zh' ? item.name : item.en_name}}
				</div>
			</div>
		</div>
		<div class="grzx-right">
			<div class="hyzj-news-list">
				<div class="hyzj-news-box" v-for="(item, index) in dataList" :key="index" @click="toDetails(item.id)">
					<div class="news-left">
						<img :src="item.image" alt="">
					</div>
					<div class="news-right">
						<div class="news-title">
							{{item.title}}
						</div>
						<div class="news-content">
							{{item.content}}
						</div>
						<div class="news-bottom">
							<div class="news-type" :style="{backgroundColor: item.sc_type == '活动' ? '#DF7D49' : '#497FDF'}">
								{{item.sc_type}}
							</div>
							<div class="news-time">
								{{item.createTime}}
							</div>

						</div>
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getData"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				leftList: [
					{
						name: '个人信息',
						en_name: 'Information',
						path: '/grxx',
						icon: 'iconyonghu1'
					},
					{
						name: '我的门票预约',
						en_name: 'Ticket',
						path: '/wdmpyy',
						icon: 'iconmenpiao'
					},
					{
						name: '我的活动预约',
						en_name: 'Activity',
						path: '/wdhdyy',
						icon: 'iconliwu'
					},
					// {
					// 	name: '我的点赞',
					// 	path: '/wddz',
					// 	icon: 'icondianzan'
					// },
					// {
					// 	name: '我的收藏',
					// 	path: '/wdsc',
					// 	icon: 'iconcollection-b'
					// },
				],
				selectIndex: 4,
				params: {

				},
				dataList: [],
				userInfo: {

				},
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../static/hyzx_top.png'
			that.getUserInfo()
		},
		methods: {
			successUpload(res) {
				let that = this
				if(res.code === 'S200') {
					that.$http.post({
						url: '/api/user/ck/updateUser',
						data: {
							id: that.$http.getStorage('userId'),
							headImg: res.data.id
						}
					}).then(ress => {
						if(ress.code === 'S200') {
							that.getUserInfo()
						} else {
							that.$Message.error(ress.msg)
						}
					})
				}
			},
			getUserInfo() {
				let that = this
				that.$http.post({
					url: '/api/user/ck/getUserDetail',
					data: {
						id: that.$http.getStorage('userId')
					}
				}).then(res => {
					if(res.code === 'S200') {
						if(res.data) {
							that.userInfo = res.data
						} else {
							that.userInfo = {}
						}
					} else if(res.code === 'F001') {
						that.$router.push('login')
					}
				})
			},
			jumpTo(index) {
				let that = this
				if(index === that.selectIndex) {
					return
				}
				that.$router.push(that.leftList[index].path)
			},
			getData(dataList) {
				let that = this
				that.dataList = dataList
			},
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 30px 10% 150px;
		display: flex;
		justify-content: space-between;
		.grzx-left {
			width: 15%;
			padding: 10px 20px;
			background-color: #F6F8FF;
			height: 550px;
			.user-name {
				color: #264EA7;
				font-size: 16px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				height: 30px;
				line-height: 30px;
			}
			.user-head {
				width: 75px;
				height: 75px;
				margin: 10px auto;
				border-radius: 50%;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.change-head-button {
				width: 115px;
				height: 25px;
				line-height: 25px;
				margin: 0 auto;
				text-align: center;
				background-color: #264EA7;
				border-radius: 10px;
				color: #FFFFFF;
				font-size: 9px;
				cursor: pointer;
			}
			.user-level {
				width: 70%;
				margin: 10px auto;
				display: flex;
				justify-content: center;
				height: 25px;
				.left {
					border-top: 3px solid #D3D3D3;
					border-bottom: 3px solid #D3D3D3;
					color: #D3D3D3;
					display: flex;
					i {
						font-size: 14px;
					}
				}
				.right {
					background-color: #EDD68E;
					color: #0E40DF;
					font-size: 12px;
					line-height: 25px;
					padding: 0 10px;
				}
			}
			.user-point {
				color: #264EA7;
				font-size: 12px;
				height: 30px;
				line-height: 30px;
			}
			.grzx-box {
				height: 60px;
				line-height: 60px;
				text-align: left;
				display: flex;
				font-size: 13px;
				color: #686868;
				cursor: pointer;
				.iconfont {
					font-size: 16px;
					color: #2D5AC3;
				}
			}
		}
		.grzx-right {
			width: 80%;
			.hyzj-news-list {
				margin-bottom: 20px;
				.hyzj-news-box {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border-bottom: 1px solid #B4B4B4;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #686868;
							font-size: 9px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-bottom {
							margin-top: 10px;
							display: flex;
							.news-type {
								padding: 2px 15px;
								border-radius: 3px;
								color: #FFFFFF;
								font-size: 11px;
							}
							.news-time {
								color: #686868;
								font-size: 9px;
								margin-left: 30px;
								padding: 2px 0;
							}
						}
					}
				}
				.hyzj-news-box:hover {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border: 1px solid #EDD68E;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #686868;
							font-size: 9px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-bottom {
							margin-top: 10px;
							display: flex;
							.news-type {
								padding: 2px 15px;
								border-radius: 3px;
								color: #FFFFFF;
								font-size: 11px;
							}
							.news-time {
								color: #686868;
								font-size: 9px;
								margin-left: 30px;
								padding: 2px 0;
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/user_center/wdsc.vue